import EnquiryEntriesDesktopLayout from "@/app/app-shared/enquiry-entrties/desktop/EnquiryEntriesDesktopLayout";
import { useCallback, useState } from "react";
import LeadsFeedbackPage from "./LeadsFeedbackPage";
import { Tab } from "rizzui";
import useProfile from "@/hooks/use-profile";
import { Roles } from "@/utilities/types/Users";

enum LeadTabs {
  AllLeads = "all-leads",
  LeadsFeedback = "leads-feedback",
}

const tabItems = [
  {
    label: "All Leads",
    value: LeadTabs.AllLeads,
  },
  {
    label: "Leads Feedback",
    value: LeadTabs.LeadsFeedback,
  },
];

function EnquiryEntriesPage() {
  const { profile } = useProfile();
  const [activeTab, setActiveTab] = useState("all-leads");

  const renderTabContent = useCallback(() => {
    switch (activeTab) {
      case LeadTabs.AllLeads:
        return <EnquiryEntriesDesktopLayout />;
      case LeadTabs.LeadsFeedback:
        return <LeadsFeedbackPage />;
      default:
        return <EnquiryEntriesDesktopLayout />;
    }
  }, [activeTab]);

  if (profile?.role === Roles.ADMIN) {
    return <EnquiryEntriesDesktopLayout />;
  }

  return (
    <>
      <div className="space-y-6">
        <Tab>
          <Tab.List className="mb-6">
            {tabItems.map((item) => (
              <Tab.ListItem
                key={item.value}
                className={
                  "cursor-pointer px-4 py-2 text-sm font-medium rounded-lg transition-colors"
                }
                onClick={() => setActiveTab(item.value)}
              >
                {item.label}
              </Tab.ListItem>
            ))}
          </Tab.List>
        </Tab>
        {renderTabContent()}
      </div>
    </>
  );
}

export default EnquiryEntriesPage;
